const adminForm = {
  CreateCustomer: [
    {
      type: 'Input',
      label: 'Customer Name',
      class: 'col-md-3',
      placeHolder: '',
      name: 'CustomerName',
      id: 'CustomerName',
      style: {},
      required: true
    },
    {
      type: 'Input',
      label: 'Telephone',
      name: 'Telephone',
      class: 'col-md-3',
      id: 'Telephone',
      style: {},
      required: false
    },
    {
      type: 'Input',
      label: 'RFC',
      name: 'RFC',
      class: 'col-md-3',
      id: 'RFC',
      style: {},
      required: true
    },
    {
      type: 'Select',
      options: 'CountryId',
      label: 'Country',
      name: 'Country',
      placeHolder: 'Select',
      class: 'col-md-3',
      id: 'Country',
      style: {},
      required: false
    },
    // {
    //   type: 'Input',
    //   label: 'Customer code',
    //   class: 'col-md-3',
    //   placeHolder: '',
    //   name: 'CustomerCode',
    //   id: 'CustomerCode',
    //   style: {},
    // },
    // {
    //   type: 'multiCombo',
    //   label: 'Module',
    //   class: 'col-md-4',
    //   placeHolder: 'Selección',
    //   name: 'multiCombo',
    //   id: 'multiCombo',
    //   required: true,

    // },

  ],
  AddContact: [
    {
      type: 'Input',
      label: 'Name',
      class: 'col-md-3',
      placeHolder: '',
      name: 'name',
      id: 'Nombre',
      style: {},
      required: true
    },
    {
      type: 'Input',
      label: 'Last Name',
      name: 'Lastname',
      class: 'col-md-2',
      id: 'Apellido',
      style: {},
      required: true
    },
    {
      type: 'Input',
      label: 'Position',
      name: 'Position',
      class: 'col-md-2',
      id: 'Posicion',
      style: {},
      required: false
    },
    {
      type: 'Input',
      label: 'Telephone',
      class: 'col-md-2',
      placeHolder: '',
      name: 'Telephone',
      id: 'Telefono',
      style: {},
      required: false
    },
    {
      type: 'Input',
      label: 'Email',
      class: 'col-md-3',
      placeHolder: '',
      name: 'Email',
      id: 'Email',
      style: {},
      required: true
    },
  ],
  CreateUser: [
    {
      type: 'Input',
      label: 'Name',
      class: 'col-md-3',
      placeHolder: '',
      name: 'name',
      id: 'Name',
      style: {},
      required: true
    },
    {
      type: 'Input',
      label: 'Last Name',
      name: 'Lastname',
      class: 'col-md-3',
      id: 'LastName',
      style: {},
      required: true
    },
    {
      type: 'Input',
      label: 'Position',
      name: 'Position',
      class: 'col-md-3',
      id: 'Position',
      style: {},
      required: false
    },
    {
      type: 'Input',
      label: 'Email',
      class: 'col-md-3',
      placeHolder: '',
      name: 'Email',
      id: 'Email',
      style: {},
      required: true
    },
    {
      type: 'Input',
      label: 'Password',
      class: 'col-md-3',
      placeHolder: '',
      name: 'Password',
      id: 'Password',
      style: {},
      required: true
    },
    {
      type: 'Select',
      options: 'RoleId',
      label: 'Role',
      name: 'RoleId',
      class: 'col-md-3',
      id: 'RoleId',
      style: {},
      required: true
    },
    {
      type: 'Input',
      label: 'Telephone',
      class: 'col-md-3',
      placeHolder: '',
      name: 'Telephone',
      id: 'Telephone',
      style: {},
      required: false
    },
  ],
  editUser: [
    {
      type: 'Input',
      label: 'Name',
      class: 'col-md-3',
      placeHolder: '',
      name: 'name',
      id: 'Name',
      style: {},
      required: true
    },
    {
      type: 'Input',
      label: 'Last Name',
      name: 'Lastname',
      class: 'col-md-3',
      id: 'LastName',
      style: {},
      required: true
    },
    {
      type: 'Input',
      label: 'Position',
      name: 'Position',
      class: 'col-md-3',
      id: 'Position',
      style: {},
      required: false
    },
    {
      type: 'Input',
      label: 'Email',
      class: 'col-md-3',
      placeHolder: '',
      name: 'Email',
      id: 'Email',
      style: {},
      required: true
    },
    {
      type: 'Input',
      label: 'Password',
      class: 'col-md-3',
      placeHolder: '',
      name: 'Password',
      id: 'Password',
      id2: 'Passwordedit',
      style: {},
      required: false,
      datatype:'Password'
    },
    {
      type: 'Select',
      options: 'RoleId',
      label: 'Role',
      name: 'RoleId',
      class: 'col-md-3',
      id: 'RoleId',
      style: {},
      required: true
    },
    {
      type: 'Input',
      label: 'Telephone',
      class: 'col-md-3',
      placeHolder: '',
      name: 'Telephone',
      id: 'Telephone',
      style: {},
      required: false
    },
  ],
  // editUser: [
  //   {
  //     type: 'Input',
  //     label: 'Name',
  //     class: 'col-md-3',
  //     placeHolder: '',
  //     name: 'name',
  //     id: 'Name',
  //     style: {},
  //     required: true
  //   },
  //   {
  //     type: 'Input',
  //     label: 'Last Name',
  //     name: 'Lastname',
  //     class: 'col-md-3',
  //     id: 'LastName',
  //     style: {},
  //     required: true
  //   },
  //   {
  //     type: 'Input',
  //     label: 'Position',
  //     name: 'Position',
  //     class: 'col-md-3',
  //     id: 'Position',
  //     style: {},
  //     required: false
  //   },
  //   {
  //     type: 'Input',
  //     label: 'Email',
  //     class: 'col-md-3',
  //     placeHolder: '',
  //     name: 'Email',
  //     id: 'Email',
  //     style: {},
  //     required: true
  //   },
  //   {
  //     type: 'Input',
  //     label: 'Password',
  //     class: 'col-md-3',
  //     placeHolder: '',
  //     name: 'Password',
  //     id: 'Password',
  //     style: {},
  //     required: false
  //   },
  //   {
  //     type: 'Select',
  //     options: 'RoleId',
  //     label: 'Role',
  //     name: 'RoleId',
  //     class: 'col-md-3',
  //     id: 'RoleId',
  //     style: {},
  //     required: true
  //   },
  //   {
  //     type: 'Input',
  //     label: 'Telephone',
  //     class: 'col-md-3',
  //     placeHolder: '',
  //     name: 'Telephone',
  //     id: 'Telephone',
  //     style: {},
  //     required: false
  //   },
  // ],
  createGroup: [
    {
      type: 'Input',
      label: 'Name',
      class: 'col-md-3',
      placeHolder: '',
      name: 'name',
      id: 'Name',
      style: {},
      required: true
    }
  ],
}
export default adminForm